import * as React from 'react';
import { Row, Col } from 'react-bootstrap';
import Utils from '../../services/Utils';
import { Hint } from '../../services/Learning';

export interface IHintComponentProps {
    hint: Hint;
}

export interface IHintComponentState {
}

export default class HintComponent extends React.Component<IHintComponentProps, IHintComponentState> {
  constructor(props: IHintComponentProps) {
    super(props);

    this.state = {
    }
  }

  public render() {
    return (
      <div>
          <Row>
                    <Col md={8}>
                        <p dangerouslySetInnerHTML={{ __html: this.props.hint.text}}>
                        </p>
                    </Col>
                    {this.props.hint.image ?
                        <Col md={4}>
                            <img src={Utils.getFileUrl(this.props.hint.image) || ''} width="100%" className='question-image'/>
                        </Col>
                    : null}
                </Row>
      </div>
    );
  }
}
